module.exports = __webpack_public_path__ + "static/media/design.f652cb86.svg";